import { Tooltip } from 'antd';
import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import CopyableText from '@fmbt/ui/CopyableText';
import FarmbotGridIcon from 'components/icons/FarmbotGridIcon';
import { SEARCH_PARAMS } from 'constants/search-params';
import { formatCoordinates } from 'utils/format-coordinates';

import './styles.less';

interface BackOfficeDeviceMapDeviceMarkerProps {
  lat: number;
  lng: number;
  deviceId: number;
  name: string;
  serialNumber: string;
  enterpriseName: string;
  ownerName: string;
}

function BackOfficeDeviceMapDeviceMarker({
  lat,
  lng,
  deviceId,
  name,
  serialNumber,
  enterpriseName,
  ownerName
}: BackOfficeDeviceMapDeviceMarkerProps): JSX.Element {
  const [, setSearchParams] = useSearchParams();

  const handleClick = useCallback(() => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE, String(deviceId));
      return newSearchParams;
    });
  }, [deviceId, setSearchParams]);

  return (
    <div className="BackOfficeDeviceMapDeviceMarker" onClick={handleClick}>
      <div className="BackOfficeDeviceMapDeviceMarker-inner">
        <div className="BackOfficeDeviceMapDeviceMarker-pin" />
        <Tooltip
          title={
            <div className="BackOfficeDeviceMapDeviceMarker-tooltip">
              <CopyableText customColor="inherit">{formatCoordinates([lat, lng])}</CopyableText>
              <div className="body-emphasis-copy">{name}</div>
              <div className="serial-number">
                <CopyableText customColor="inherit">{serialNumber}</CopyableText>
              </div>
              <div className="body-copy">{enterpriseName}</div>
              <div className="body-copy">{ownerName}</div>
            </div>
          }
        >
          <div className="BackOfficeDeviceMapDeviceMarkerButton">
            <FarmbotGridIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  );
}

export default BackOfficeDeviceMapDeviceMarker;
